import { z } from 'zod';
import { CityDto } from './city';

export const SetBroadcastChatInput = z.object({ chat: z.string().trim().min(1).max(200) }).strict();
export type SetBroadcastChatInput = z.infer<typeof SetBroadcastChatInput>;

export const SetBroadcastActiveInput = z.object({ active: z.boolean() }).strict();
export type SetBroadcastActiveInput = z.infer<typeof SetBroadcastActiveInput>;

export const BroadcastChatType = z.enum(['group', 'supergroup', 'channel']);

export const BroadcastCheckResultDto = z.object({
  ok: z.boolean(),
  chat: z.object({ id: z.string(), title: z.string(), type: BroadcastChatType }),
  botStatus: z.string(),
  canDeleteMessages: z.boolean(),
  canPostMessages: z.boolean().nullable(),
  problems: z.array(z.string()),
  warnings: z.array(z.string()),
});
export type BroadcastCheckResultDto = z.infer<typeof BroadcastCheckResultDto>;

export const EventChatBroadcastStatus = z.enum([
  'QUEUED',
  'SENDING',
  'SENT',
  'FAILED',
  'DELETING',
  'DELETED',
  'DELETE_FAILED',
]);
export type EventChatBroadcastStatus = z.infer<typeof EventChatBroadcastStatus>;

export const EventChatBroadcastDto = z.object({
  id: z.uuid(),
  eventId: z.uuid().nullable(),
  eventTitle: z.string().nullable(),
  status: EventChatBroadcastStatus,
  error: z.string().nullable(),
  sentAt: z.iso.datetime().nullable(),
  deletedAt: z.iso.datetime().nullable(),
  createdAt: z.iso.datetime(),
});
export type EventChatBroadcastDto = z.infer<typeof EventChatBroadcastDto>;

export const CityBroadcastStateDto = z.object({
  chat: z.object({ id: z.string(), title: z.string().nullable() }).nullable(),
  timezone: z.string(),
  isActive: z.boolean(),
  activatedAt: z.iso.datetime().nullable(),
  disabledReason: z.string().nullable(),
  queue: z.object({
    count: z.number().int().nonnegative(),
    next: z.array(
      z.object({ id: z.uuid(), title: z.string(), startsAt: z.iso.datetime(), hasStartTime: z.boolean() }),
    ),
  }),
  recent: z.array(EventChatBroadcastDto),
});
export type CityBroadcastStateDto = z.infer<typeof CityBroadcastStateDto>;

export const AdminCityDto = CityDto.extend({
  telegramChatTitle: z.string().nullable(),
  isBroadcastActive: z.boolean(),
});
export type AdminCityDto = z.infer<typeof AdminCityDto>;
